export default {
  avatar: {
    title: "Zmień awatar",
  },
  bindRole: {
    allServers: "Wszystkie serwery",
    bindFailed: "Nie udało się przypisać postaci",
    bindSuccess: "Postać przypisana",
    getRoleListFailed: "Nie udało się pobrać listy postaci",
    getServerListFailed: "Nie udało się pobrać listy serwerów",
    modifyTitle: "Zmień przypisaną postać",
    noRole: "Brak dostępnych postaci",
    recentServers: "Twój serwer",
    role: "Imię postaci:",
    rolePlaceholder: "Wybierz postać",
    server: "Serwer:",
    serverPlaceholder: "Wybierz serwer",
    title: "Przypisz postać",
  },
  commentModal: {
    placeholder: "Napisz komentarz...",
    replyTo: "Odpowiedz {username}",
    title: "Komentarz",
  },
  common: {
    cancel: "Anuluj",
    confirm: "OK",
    landscapeTip:
      "Proszę obrócić telefon w tryb pionowy, aby uzyskać lepsze wrażenia",
    loadMore: "Przesuń w górę, aby załadować więcej",
    loading: "Ładowanie...",
    loadingMore: "Załaduj więcej...",
    noMore: "Brak więcej danych",
    refreshFailed: "Nie udało się odświeżyć",
    refreshSuccess: "Odświeżono",
    submit: "Wyślij",
    all: "Wszystkie",
    language: "Język",
  },
  error: {
    50002: "Nieprawidłowy lub wygasły token",
    50006: "Pseudonim jest już zajęty przez innego użytkownika",
    50007:
      "Możesz zmienić swój pseudonim tylko raz w miesiącu, zmieniłeś go już w tym miesiącu",
    50008: "Niewystarczająca liczba punktów",
    50301: "Nie masz uprawnień do publikowania",
    50302: "Osiągnięto limit postów",
    50303: "Długość treści nie spełnia wymagań",
    50304: "Treść zawiera wrażliwe słowa, zmodyfikuj i spróbuj ponownie",
    50308: "Nie masz uprawnień do wyświetlenia tego posta",
    50309: "Post został usunięty lub przeniesiony",
    50351: "Wątek jest zamknięty, nie można odpowiedzieć",
    50353: "Nie masz uprawnień do odpowiadania",
    50354: "Odpowiedzi są zabronione w tej sekcji",
    50355: "Zbyt częste publikowanie, spróbuj ponownie później",
    50356: "Osiągnięto limit postów na godzinę",
    50361: "Nie znaleziono komentarza",
    50500: "Nie możesz jeszcze korzystać z funkcji wyszukiwania",
    50501: "Funkcja wyszukiwania wyłączona",
    50502: "Treść zawiera wrażliwe słowa, zmodyfikuj i spróbuj ponownie",
    50505: "Wyszukiwanie zbyt częste, spróbuj ponownie później",
    50703: "Weryfikacja obrazu nie powiodła się",
    50704: "Zawartość obrazu nie spełnia standardów",
    50214: "Udostępnianie nie powiodło się: nie dołączyłeś do żadnej @:shareModal.alliance.",
    common: "Operacja nie powiodła się, spróbuj ponownie później.",
  },
  home: {
    gameName: "Puzzles & Survival",
    hasSigned: "Zalogowano",
    loginInSuccess: "Logowanie udane",
    pleaseLogin: "Najpierw się zaloguj.",
    loginNow: "Zaloguj się",
    pullToRefresh: "Przesuń w dół, aby odświeżyć",
    releaseToRefresh: "Puść, aby odświeżyć",
    signFailed: "Logowanie nie powiodło się",
    signIn: "Zaloguj się",
    signInFailedTip: "Logowanie nie powiodło się, spróbuj ponownie później",
    signSuccess: "Logowanie udane",
    goToShop: "Przejdź do Centrum Punktów",
    sortByLastPost: "Najnowsze komentarze",
    sortByTime: "Najnowsze",
    tags: {
      activity: "Wydarzenie",
      chats: "Dyskutuj",
      guide: "Przewodnik",
      recommend: "Poleć",
      news: "Wiadomości",
    },
    unboundRole: "Postać nie jest przypisana",
  },
  linkModal: {
    close: "Close",
    textLabel: "Link Text",
    textPlaceholder: "Please enter link text",
    title: "Insert Link",
    urlLabel: "Link URL",
    urlPlaceholder: "Please enter link URL",
    viewTitle: "View Link",
  },
  maintenance: {
    title: "Konserwacja",
    message:
      "Przepraszamy, forum gry jest obecnie w trakcie konserwacji. Proszę spróbować ponownie później.",
  },
  mentionModal: {
    searchPlaceholder: "Wyszukaj użytkownika",
    title: "Wybierz użytkownika",
  },
  nicknameModify: {
    alreadyRenamed:
      "Pseudonim można zmieniać tylko raz w miesiącu, a ty już to zrobiłeś w tym miesiącu.",
    changedNickname: "Zmień pseudonim",
    cost: "Koszt",
    date: "Data",
    getMore: "Zdobądź",
    nicknameTooShort: "Nazwa musi mieć co najmniej 3 znaki",
    coinNotEnough: "Niewystarczająca liczba punktów",
    placeholder: "Wprowadź pseudonim",
    recordTitle: "Historia edycji",
    sameNickname: "Nowy pseudonim nie może być taki sam jak obecny.",
    success: "Zmiana zapisana",
    viewRecord: "Historia edycji",
  },
  notice: {
    empty: "Brak wiadomości",
    likeComment: "{username} polubił(a) twój komentarz",
    likePost: "Użytkownik {username} polubił twój post",
    mentionComment: "{username} wspomniał(a) o twoim komentarzu",
    mentionPost: "{username} wspomniał(a) o twoim poście",
    replyComment: "{username} odpowiedział(a) na twój komentarz",
    replyPost: "{username} odpowiedział(a) na twój post",
    system: "Powiadomienie systemowe",
    tabs: {
      like: "Polubienie",
      mention: "Wspomniał(a) o mnie",
      notification: "Powiadomienie",
      reply: "Odpowiedział(a) mi",
    },
    title: "Powiadomienie o wiadomości",
  },
  operateModal: {
    confirmDelete: "Czy na pewno chcesz usunąć ten post?",
    copyFailed: "Nie udało się skopiować",
    copyLink: "Kopiuj link",
    copySuccess: "Skopiowano",
    delete: "Usuń",
    shareToGame: "Udostępnij w grze",
    deleteFailed: "Nie udało się usunąć",
    deleteSuccess: "Usunięto",
    title: "Akcja",
  },
  shareModal: {
    selectChannelTitle: "Wybierz kanał do udostępnienia",
    channelLabel: "Kanał",
    channelPlaceholder: "Wybierz kanał",
    alliance: "Sojusz",
    shareSuccess: "Udostępniono pomyślnie",
    continueBrowse: "Kontynuuj przeglądanie",
    goToGame: "Zobacz w grze",
    noThreadTip: "Otwórz najpierw post",
  },
  post: {
    create: {
      contentEmpty: "Treść nie może być pusta",
      contentPlaceholder: "Napisz coś...",
      failed: "Nie udało się opublikować",
      fileTooLarge: "Rozmiar pliku przekracza limit (max {maxSize})",
      image: "Obraz",
      imageSizeLimit: "Rozmiar obrazu musi być poniżej 5 MB",
      imageUploadFailed: "Nie udało się przesłać zdjęcia",
      imageUploadSuccess: "Zdjęcie przesłane",
      imageUploading: "Przesyłanie zdjęcia, proszę czekać.",
      invalidFileType: "Nieobsługiwany typ pliku",
      maxCharsReached: "Osiągnięto maksymalną liczbę znaków ({max} znaków)",
      mention: "{'@'}",
      selectBoard: "Wybierz sekcję",
      topicLabel: "Temat",
      submit: "Post",
      submitting: "Publikowanie...",
      success: "Opublikowano",
      title: "Opublikuj",
      titleEmpty: "Tytuł nie może być pusty",
      titlePlaceholder: "Wpisz tytuł",
      video: "Wideo",
      videoSizeLimit: "Rozmiar wideo musi być poniżej 50 MB",
      videoUploadFailed: "Nie udało się przesłać filmu",
      videoUploadSuccess: "Film przesłany",
      videoUploading: "Trwa przesyłanie filmu, proszę czekać...",
    },
    title: "Post",
  },
  postDetail: {
    allComments: "Wszystkie {num} odpowiedzi",
    allReplies: "Odpowiedz wszystkim",
    author: "Autor",
    cancelFavorite: "Usunięto z ulubionych",
    commentTooShort: "Komentarz musi mieć co najmniej 5 znaków",
    translate: "Tłumacz",
    translating: "Tłumaczenie...",
    translateSuccess: "Tłumaczenie zakończone sukcesem",
    translateFailed: "Tłumaczenie nie powiodło się",
    translatedTo: "Przetłumaczono na",
    earliest: "Najwcześniejsza odpowiedź",
    favoriteSuccess: "Dodano do ulubionych",
    floor: "Floor",
    latest: "Najnowsza odpowiedź",
    loadFailed: "Nie udało się załadować",
    noContent: "Brak treści",
    onlyAuthor: "Tylko autor",
    reply: "Odpowiedz",
    replyTo: "Odpowiedz",
    sendFailed: "Nie udało się wysłać",
    sendSuccess: "Wysłano",
    sending: "Wysyłanie...",
    viewOriginalPost: "Pierwotny post",
    writeSomething: "Mówi coś...",
  },
  profile: {
    addLikeSuccess: "Polubione",
    cancelLikeSuccess: "Nielubiane",
    communityId: "ID społeczności",
    editNickname: "Zmień pseudonim",
    followSuccess: "Obserwowani",
    followed: "Obserwowane",
    followers: "Obserwujący",
    follow: "Obserwuj",
    likes: "Polubienia",
    noFavorites: "Brak ulubionych",
    noPosts: "Brak aktualizacji",
    shopLabel: "Sklep Punktów",
    tabs: {
      favorites: "Moje ulubione",
      posts: "Moje aktualizacje",
    },
    title: "Profil",
    unfollowSuccess: "Przestano obserwować",
  },
  search: {
    btn: "Szukaj",
    empty: "Brak powiązanych treści",
    filter: {
      dateline: "Najnowsze",
      title: "Sortuj",
      views: "Popularne",
    },
    historyTitle: "Historia wyszukiwania",
    hotTitle: "Popularne",
    relatedPosts: "Powiązane posty",
    tabs: {
      post: "Post",
      user: "Użytkownik",
    },
  },
  setting: {
    about: "O nas",
    logout: "Wyloguj się",
    logoutSuccess: "Wylogowano",
    privacy: "Polityka prywatności",
    service: "Warunki korzystania z usługi",
    title: "Ustawienia",
  },
  shop: {
    emptyTip: "Sklep w budowie, bądźcie czujni",
    record: "Historia wymiany",
    title: "Centrum wymiany",
    bindRole: "Powiąż postać",
    switchRole: "Switch Character",
    tabs: {
      tasks: "Zadania punktowe",
      rewards: "Wymiana nagród",
    },
    taskInProgress: "W toku",
    taskCompleted: "Ukończone",
    goToComplete: "Zadanie",
    exchange: "Wymień",
    exchanged: "Wymienione",
    exchangeConfirmTitle: "Potwierdzić wymianę?",
    currentCoins: "Aktualne punkty",
    costCoins: "Punkty do zużycia",
    receiveRole: "Postać odbiorca",
    exchangeSuccess: "Wymiana udana",
    exchangeFailed: "Wymiana nieudana",
  },
  exchangeRecord: {
    time: "Czas",
    content: "Treść",
    points: "Punkty",
    empty: "Brak historii wymiany",
  },
  tabBar: {
    home: "Strona główna",
    notice: "Wiadomości",
    profile: "Moje",
  },
  time: {
    hoursAgo: "{hours} godz. temu",
    minutesAgo: "{minutes} min temu",
  },
};
